/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  DeleteClientBankAccount: (params: vp.DeleteClientBankAccountRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostDeleteClientBankAccount: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldDeleteClientBankAccount, setShouldDeleteClientBankAccount] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.DeleteClientBankAccountRequest>({
    PortalUser: '',
    Token: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldDeleteClientBankAccount) return () => {};

    const PostDeleteClientBankAccount = async () => {
      setDataFetchingInfo(true, 'Deleting account', 'fullScreen');
      const res = await api.postDeleteClientBankAccount(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldDeleteClientBankAccount) void PostDeleteClientBankAccount();
    setShouldDeleteClientBankAccount(false);
    return () => {
      source.cancel();
    };
  }, [shouldDeleteClientBankAccount]);

  return [
    response,
    (_params: vp.DeleteClientBankAccountRequest) => {
      setParams(_params);
      setShouldDeleteClientBankAccount(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldDeleteClientBankAccount(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostDeleteClientBankAccount);